import { ArrowUpRight, CheckCircle2 } from 'lucide-react';
import { Link } from 'react-router-dom';
import { products } from '../mock';

export default function ProductsSection() {
  return (
    <section id="products" className="bg-white py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-8 mb-14">
          <div>
            <div className="font-mono text-[11px] uppercase tracking-[0.18em] text-amber-600 mb-4">
              — Our Premium Offerings
            </div>
            <h2 className="font-display text-4xl lg:text-5xl font-semibold text-[#0b0b0d] max-w-2xl leading-[1.05]">
              Electrodes engineered for every kind of weld.
            </h2>
          </div>
          <p className="text-neutral-600 max-w-md text-base leading-relaxed">
            Five trusted brands. One relentless standard of quality. Each rod is crafted with the
            precision that comes from four decades of experience.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {products.slice(0, 3).map((p) => (
            <ProductCard key={p.id} product={p} />
          ))}
          {products.slice(3).map((p) => (
            <ProductCard key={p.id} product={p} wide />
          ))}
        </div>

        <div className="mt-14 flex justify-center">
          <Link
            to="/products"
            className="group inline-flex items-center gap-2 font-medium text-[#0b0b0d] hover:text-amber-600 transition-colors"
          >
            View complete catalogue
            <ArrowUpRight className="h-4 w-4 group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform" />
          </Link>
        </div>
      </div>
    </section>
  );
}

function ProductCard({ product, wide }) {
  return (
    <div
      className={`card-lift group relative overflow-hidden rounded-2xl border border-neutral-200 bg-white ${
        wide ? 'lg:col-span-3 md:col-span-2 md:flex' : ''
      }`}
    >
      <div
        className={`relative overflow-hidden bg-gradient-to-br from-neutral-50 via-white to-neutral-100 border-b border-neutral-200 ${
          wide ? 'md:w-1/2 aspect-video md:aspect-auto md:border-b-0 md:border-r' : 'aspect-[4/3]'
        }`}
      >
        <div className="absolute inset-0 flex items-center justify-center p-6">
          <img
            src={product.image}
            alt={product.name}
            className={`${product.imgFit === 'cover' ? 'h-full w-full object-cover' : 'max-h-full max-w-full object-contain'} group-hover:scale-105 transition-transform duration-700`}
          />
        </div>
        <div className="absolute top-4 left-4 font-mono text-[10px] uppercase tracking-[0.18em] text-[#0b0b0d]/80 bg-white/80 backdrop-blur px-2.5 py-1 rounded border border-neutral-200">
          {product.subtitle}
        </div>
      </div>

      <div className={`p-6 lg:p-8 ${wide ? 'md:w-1/2 md:flex md:flex-col md:justify-center' : ''}`}>
        <h3 className="font-display text-2xl font-semibold text-[#0b0b0d]">
          {product.name}
        </h3>
        <p className="mt-3 text-neutral-600 text-sm leading-relaxed">{product.description}</p>

        <div className="mt-5 grid grid-cols-2 gap-2">
          {product.features.map((f) => (
            <div key={f} className="flex items-center gap-2 text-xs text-neutral-700">
              <CheckCircle2 className="h-3.5 w-3.5 text-amber-600 shrink-0" />
              {f}
            </div>
          ))}
        </div>

        <Link
          to="/contact"
          className="mt-6 inline-flex items-center gap-1.5 text-sm font-semibold text-[#0b0b0d] group-hover:text-amber-600 transition-colors"
        >
          Enquire now <ArrowUpRight className="h-4 w-4" />
        </Link>
      </div>
    </div>
  );
}
